import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { buttonClasses, type ButtonSize, type ButtonVariant } from '../../utils/buttonStyles';
interface ButtonLinkProps {
  to?: string;
  href?: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
  arrow?: boolean;
  children: ReactNode;
  ariaLabel?: string;
}
export function ButtonLink({
  to,
  href,
  variant = 'primary',
  size = 'md',
  className = '',
  arrow = false,
  children,
  ariaLabel
}: ButtonLinkProps) {
  const classes = buttonClasses(variant, size, className);
  const content = <>
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-466" data-mp="1isy6jnhljo8w" />}
    </>;
  if (href) {
    return <a href={href} className={classes} aria-label={ariaLabel} data-id="element-467" data-mp="1nrt27q0nx7af">
        {content}
      </a>;
  }
  return <Link to={to ?? '/'} className={classes} aria-label={ariaLabel} data-id="element-468" data-mp="3i3zb2i633bzk">
      {content}
    </Link>;
}